import { h, mount, clear } from './dom.js';

// --- Toast ---
let toastStack = null;
function ensureStack() {
  if (toastStack) return toastStack;
  toastStack = h('div', { class: 'toast-stack', role: 'status', 'aria-live': 'polite' });
  document.body.appendChild(toastStack);
  return toastStack;
}
export function toast(msg, { type = '', duration = 3200 } = {}) {
  const stack = ensureStack();
  const t = h('div', { class: `toast ${type}` }, msg);
  stack.appendChild(t);
  setTimeout(() => {
    t.style.opacity = '0';
    t.style.transition = 'opacity 200ms';
    setTimeout(() => t.remove(), 220);
  }, duration);
}

// --- Modal ---
let currentModal = null;
export function openModal({ title, body, actions, size = 'md', onClose }) {
  closeModal();
  const closeBtn = h('button', {
    class: 'btn btn-ghost btn-icon', 'aria-label': 'Kapat',
    onclick: () => closeModal(),
  }, '✕');
  const head = h('div', { class: 'modal-head' },
    h('h3', {}, title),
    closeBtn,
  );
  const bodyEl = h('div', { class: 'modal-body' });
  if (typeof body === 'function') body(bodyEl);
  else if (body instanceof Node) bodyEl.appendChild(body);
  else if (body) bodyEl.innerHTML = String(body);

  const foot = h('div', { class: 'modal-foot' });
  (actions || []).forEach(a => foot.appendChild(a));

  const modal = h('div', { class: 'modal', style: { maxWidth: size === 'lg' ? '720px' : '560px' } },
    head, bodyEl, actions?.length ? foot : null,
  );
  const overlay = h('div', {
    class: 'modal-overlay',
    onclick: (e) => { if (e.target === overlay) closeModal(); },
  }, modal);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';
  currentModal = { overlay, onClose };
  document.addEventListener('keydown', onEsc);
  setTimeout(() => modal.querySelector('input, textarea, select, button')?.focus(), 40);
}
export function closeModal() {
  if (!currentModal) return;
  const { overlay, onClose } = currentModal;
  overlay.remove();
  document.body.style.overflow = '';
  document.removeEventListener('keydown', onEsc);
  currentModal = null;
  if (typeof onClose === 'function') onClose();
}
function onEsc(e) { if (e.key === 'Escape') closeModal(); }

export function confirmModal({ title = 'Emin misin?', message, confirmText = 'Onayla', danger = false, onConfirm }) {
  openModal({
    title,
    body: h('p', { class: 'muted' }, message),
    actions: [
      h('button', { class: 'btn btn-ghost', onclick: closeModal }, 'Vazgeç'),
      h('button', {
        class: `btn ${danger ? 'btn-danger' : 'btn-primary'}`,
        onclick: async () => { try { await onConfirm(); } finally { closeModal(); } }
      }, confirmText),
    ],
  });
}
